import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import EmojiRadioInput from "../../Components/EmojiRadioInput/EmojiRadioInput";
import HyperLocal from "../../Data/Hyperlocal";
import InputErrorMessage from "../../Components/InputErrorMessage/InputErrorMessage";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import "./HyperLocalNetworks.css";

class HyperLocalNetworks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showButton: false,
      city: "",
      otherCity: "",
      error: "",
      isLoading: true,
    };

    this.handleRadioInputOnChange = this.handleRadioInputOnChange.bind(this);
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (decoded.active) {
        this.props.history.push("/dashboard");
      } else if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData
      ) {
        this.props.history.push("/for-founders-by-founders");
      } else {
        let userData = this.props.location.state.userData;
        const { user_type } = userData;
        if (!user_type) {
          this.props.history.push("/for-founderd-by-founders", {
            userData: userData,
          });
        } else {
          if (this.props.city !== "" && this.props.otherCity !== "") {
            if (
              this.props.city !== "austin" &&
              this.props.otherCity !== "austin"
            ) {
              this.setState({
                city: this.props.city,
                otherCity: this.props.otherCity,
                isLoading: false,
              });
            } else {
              this.setState({
                city: this.props.city,
                isLoading: false,
              });
            }
          } else {
            this.setState({
              isLoading: false,
            });
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.city !== "" && this.state.city !== prevState.city) {
      this.setState({
        showButton: true,
      });
    }
  }

  handleRadioInputOnChange(e, value) {
    this.props.setCity(value);
    this.props.setOtherCity(value);
    this.setState({
      city: value,
      otherCity: value,
    });
  }

  handleSelectValueChange(value) {
    this.props.setCity("other");
    this.props.setOtherCity(value);
    this.setState({
      otherCity: value,
    });
  }

  handleNextStep() {
    let userData = this.props.location.state.userData;

    if (this.state.city !== "austin") {
      // if (this.state.otherCity !== "") {
      this.props.history.push("/hyperlocal-networks/other-city", {
        userData: {
          ...userData,
          otherCity: this.state.otherCity,
        },
      });
      // } else {
      //   this.setState({
      //     error: "Please select a city",
      //   });
      // }
    } else {
      this.props.history.push("/policy-agreement", {
        userData: {
          ...userData,
          city: this.state.city,
        },
      });
    }
  }

  handleBackButton() {
    this.props.history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}
        <RegistrationForm
          containerClassName="container-hyperlocal-network"
          hasCounter={false}
          hasQuote={true}
          quote="For now, Astronomic is all about connecting local entrepreneurs. Which city do you live nearest?"
          headerText="Glad to have you"
          primaryButtonText="Next step"
          hasSkip={false}
          showButton={this.state.showButton}
          showBackButton={true}
          backButtonText="Back"
          handlePrimaryBtnOnClick={this.handleNextStep}
          activatePrimaryWithEnter={true}
          handleBackButtonClick={this.handleBackButton}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          <div className="form-container-body-row">
            <EmojiRadioInput
              data={HyperLocal}
              name="hyper-local-network"
              incomingValue={this.state.city}
              inputValue={this.state.otherCity}
              onChange={this.handleRadioInputOnChange}
              handleonChangeValue={this.handleSelectValueChange}
              zIndexValue={5}
            />
            {this.state.error !== "" ? (
              <InputErrorMessage errorText={this.state.error} />
            ) : null}
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default withRouter(HyperLocalNetworks);
